const initCurrentVersion = { id: 1, version: "Draft-Version", timestamp: 0 };

const initState = {
    type: '',
    versionList: [],
    currentVersion: initCurrentVersion,
    response: null,
    error: null
}

const versionReducer = (state = initState, action) => {

    switch (action.type) {
        case 'VERSION_LIST_PENDING':     return { ...state, type: action.type, error: null }
        case 'VERSION_LIST_SUCCESS':     return { ...state, type: action.type, error: null, versionList: action.payload}
        case 'VERSION_LIST_ERROR':       return { ...state, type: action.type, error: action.payload, versionList: [] }

        case 'VERSION_SELECT_PENDING':   return { ...state, type: action.type, error: null }
        case 'VERSION_SELECT_SUCCESS':   return { ...state, type: action.type, error: null, currentVersion: action.payload}
        case 'VERSION_SELECT_ERROR':     return { ...state, type: action.type, error: action.payload }

        case 'VERSION_CREATE_PENDING':   return { ...state, type: action.type, error: null }
        case 'VERSION_CREATE_SUCCESS':   return { ...state, type: action.type, error: null, currentVersion: action.payload}
        case 'VERSION_CREATE_ERROR':     return { ...state, type: action.type, error: action.payload }

        case 'VERSION_UPDATE_PENDING':   return { ...state, type: action.type, error: null }
        case 'VERSION_UPDATE_SUCCESS':   return { ...state, type: action.type, error: null, response: action.payload}
        case 'VERSION_UPDATE_ERROR':     return { ...state, type: action.type, error: action.payload }

        case 'VERSION_DELETE_PENDING':   return { ...state, type: action.type, error: null }
        case 'VERSION_DELETE_SUCCESS':   return { ...state, type: action.type, error: null, response: action.payload, currentVersion: initCurrentVersion }
        case 'VERSION_DELETE_ERROR':     return { ...state, type: action.type, error: action.payload }

        
        default: return state;
    }
};

export default versionReducer;